import React, { useState, useEffect, useContext, useRef } from "react";
import { Button, Carousel, Modal, Tab, Tabs, Form } from "react-bootstrap";
import { Spinner } from "react-bootstrap";
import addmore from "../../assets/images/Overview/Add-more.svg";
import previousarrow from "../../assets/images/icons/Previous-Arrow.svg";
import nextarrow from "../../assets/images/icons/Next-arrow.svg";
import wallet from "../../assets/images/Overview/wallet.svg";
import chevron from "../../assets/images/Overview/chevron-down.svg";
import creditcard from "../../assets/images/Overview/credit-card.svg";
import visa from "../../assets/images/Overview/VISA.svg";
import '../../assets/css/feather.css';
import TableCard from "../../components/CoverageTable.jsx";
import RecentBilling from "../../components/RecentBilling";
import AutoRead from "../../components/AutoReadPage.jsx";
import APTCdetails from "../../components/aptcdetails";
import STPSDetails from "../../components/STPSDetails";
import STPS2Details from "../../components/STPS2Details";
import STPS3Details from "../../components/STPS3Details";
import ViewDetailsModal from "../../components/modal";
import Schedulepayment from "../../components/schedulepayment";
import Forms from "../../components/forms";
import MultipleAccounts from "../../components/multipleAccounts";
import RemoveAccounts from "../../components/removeAccounts";
import '../../assets/css/Style.css';
import '../../styles/overviewResponsive.css';
import AgentTable from "../../components/agentTable";
import { getApiService } from "../../services/ApiService";
import { LanguageContext } from "../../contexts/LanguageContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { GetPayLoad } from "../../services/PayLoadStorage";
import bank from "../../assets/images/icons/Bank.svg";
import mastercard from "../../assets/images/icons/mastercard.svg";
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from "uuid";
import { getAPIData } from "../../services/EncryptService";
import Cookies from 'js-cookie';
import UseFavicon from '../../components/favIcons';
import RenewalModal from "../../components/RenewalModal";
import MarketExitModal from "../../components/MarketExitModal"; // PMO0003735 - Show Market Exit Pop up for medical product types during market exit period - st48236
import { getCookieOptions } from '../../utils/cookieUtils';
import { handleFiservLogin } from "../../services/FiservLoginService";

const Overview = () => {

    UseFavicon('/favicons/' + Cookies.get('owningCarrier') + '.svg');
    const dropdownRef = useRef(null);
    const buttonRef = useRef(null);
    const [show, setShow] = useState(false);
    const [target, setTarget] = useState(null);
    const ref = useRef(null);
    const [isContentReady, setContentReady] = useState(false); // st48236 - 508 compliance Track when all API responses are received
    const [apiCallsCompleted, setApiCallsCompleted] = useState(false); // st48236 - 508 compliance Track when all API calls are completed

    const [showSTPS, setShowSTPS] = useState(false);
    const [showSTPS2, setShowSTPS2] = useState(false);
    /* PMO0004087 CHG0127827 SD47534 */
    const [showSTPS3, setShowSTPS3] = useState(false);
    const [showAPTC, setShowAPTC] = useState(false);
    const [viewIcon, setViewIcon] = useState(null);

    //This  is Localstorage value
    const Payload = GetPayLoad('PayLoad');

    const [readOnlyMode, setReadOnlyMode] = useState(false);

    // Set icons based on owning carrier
    let owningCarrier = Payload?.owning_carrier || '';
    const connectiCareCarrier = Cookies.get("connectiCareCarrier") || null;
    const isConnectiCareCarrier = Cookies.get("isConnectiCareCarrier") || 'false';

    const [overViewPayIcon, setOverViewPayIcon] = useState(null);
    const [healthPlanIcon, setHealthPlanIcon] = useState(null);
    // st48236 - Show message after payment is done - BA raised request - start
    const [afterPaidIcon, setAfterPaidIcon] = useState(null);
    const [afterPaidTickIcon, setAfterPaidTickIcon] = useState(null);
    // st48236 - Show message after payment is done - BA raised request - end

    const [changePrimaryIcon, setChangePrimaryIcon] = useState(null);
    const [trashIcon, setTrashIcon] = useState(null);

    useEffect(() => {

        // Set read-only mode based on payload value, default to false if not set
        setReadOnlyMode(Payload?.readOnlyAccess === true);

        // When ConnectiCare carrier is set, override owningCarrier
        owningCarrier = ( isConnectiCareCarrier === 'true' && connectiCareCarrier !== null && connectiCareCarrier !== undefined) ? connectiCareCarrier : owningCarrier;
        
        import("../../assets/images/icons/overview-"+owningCarrier+".svg").then((image) => {
            setOverViewPayIcon(image.default);
        }).catch((error) => {
            import("../../assets/images/icons/overview.svg").then((image) => {
                setOverViewPayIcon(image.default);
            });
        });

        // st48236 - Show message after payment is done - BA raised request - start
        import("../../assets/images/icons/AfterPaid-"+owningCarrier+".svg").then((image) => {
            setAfterPaidIcon(image.default);
        }).catch((error) => {
            import("../../assets/images/icons/AfterPaid.svg").then((image) => {
                setAfterPaidIcon(image.default);
            });
        });
        import("../../assets/images/icons/AfterTick-"+owningCarrier+".svg").then((image) => {
            setAfterPaidTickIcon(image.default);
        }).catch((error) => {
            import("../../assets/images/icons/AfterTick.svg").then((image) => {
                setAfterPaidTickIcon(image.default);
            });
        });
        // st48236 - Show message after payment is done - BA raised request - end

        import("../../assets/images/Illustrations/Health-plan-"+owningCarrier+".svg").then((image) => {
            setHealthPlanIcon(image.default);
        }).catch((error) => {
            import("../../assets/images/Illustrations/Health-plan.svg").then((image) => {
                setHealthPlanIcon(image.default);
            });
        });

        if(owningCarrier === 'Q5'){
            import("../../assets/images/Overview/Change-primary-" + owningCarrier + ".svg").then((image) => {
                setChangePrimaryIcon(image.default);
            });
            import("../../assets/images/Overview/trash-" + owningCarrier + ".svg").then((image) => {
                setTrashIcon(image.default);
            });
        } else {
            import("../../assets/images/Overview/Change-primary.svg").then((image) => {
                setChangePrimaryIcon(image.default);
            });
            import("../../assets/images/Overview/trash.svg").then((image) => {
                setTrashIcon(image.default);
            });
        }

        // Dynamic import for view icon based on carrier
        import("../../assets/images/icons/view-"+owningCarrier+".svg")
                .then((image) => {
                    setViewIcon(image.default);
        }).catch(() => {
                // Load default image if carrier-specific image doesn't exist
                import("../../assets/images/icons/view.svg").then((image) => {
                    setViewIcon(image.default);
                });
        });

    }, [owningCarrier, connectiCareCarrier]);

    const handleToggle = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setShow(!show);
        setTarget(event.target);
    };

    const handleClose = () => setShow(false);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                buttonRef.current &&
                !buttonRef.current.contains(event.target)) {
                handleClose();
            }
        };

        if (show) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [show]);

    function handleDataFromModal(message, response) {
        if (message !== '' && response === 'success') {
            toast.success(message);
        } else {
            toast.error(message);
        }
        fetchPrimaryAccount(headers);
    }

    const { pageContent } = useContext(LanguageContext);
    const [overViewContent, setOverViewContent] = useState([]);
    const [genericContent, setGenericContent] = useState([]);

    const Navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
   
    const getStatusClass = (status) => {
        
        switch (status?.toLowerCase()) {
            case "termed":
                return "btn-danger";
            case "issued":
                return "btn-success";
            case "pending":
                return "btn-warning";
            case "issued-pt":
                return "btn-issued-ftd";    
            default:
                return "btn-secondary";
                
        }
    };

    const [key, setKey] = useState('case-info');
    const [key1, setKey1] = useState('bill-details');
    const [activeKey, setActiveKey] = useState(
        (Payload?.owning_carrier === 'Q5' || Payload?.owning_carrier === 'BCBSAZ') ? "0" : null
    );

    const [modal, setModal] = useState();
    const [payNow, setPayNow] = useState(false); 



    const [addNew, setAddNew] = useState(false);
    const [removeAccounts, setRemoveAccounts] = useState();
    const [caseInfo, setCaseInfo] = useState([]);
    const [agentInfo, setAgentInfo] = useState([]);
    const [coverageInfo, setCoverageInfo] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [coverageHeader, setCoverageHeader] = useState([]);
    const [agentHeaders, setAgentHeaders] = useState([]);
    const [primaryAccount, setPrimaryAccount] = useState([]);
    const [isHideCCD, setHideCCD] = useState(); // st48236 - INC0295110 - avoid display of CCD for BCBSAZ conditions only 
    const [isCaseLoading, setCaseLoading] = useState(true);
    const [isCoverageLoading, setCoverageLoading] = useState(true);
    const [isAgentLoading, setAgentLoading] = useState(true);
    const [toPayAmount, setToPayAmount] = useState([]);
    const [currentDueAmount, setCurrentDueAmount] = useState(0);
    const [dueDateDays, setDueDateDays] = useState(0);
    const [isToPayLoading, setToPayLoading] = useState(true);
    const [activeModal, setRemoveAccountsModal] = useState(true);
    const [accountsModal, setAccountsModal] = useState(true);
    const [accountModalClose, setAccountModalClose] = useState(false);
    const [accountCount, setAccountCount] = useState([]);
    const [primaryErrorFlag, setPrimaryErrorFlag] = useState(false);
    const [caseInfoErrorFlag, setCaseInfoErrorFlag] = useState(false);
    const [coverageInfoErrorFlag, setCoverageInfoErrorFlag] = useState(false);
    const [agentInfoErrorFlag, setAgentInfoErrorFlag] = useState(false);
    const [toPayErrorFlag, setToPayErrorFlag] = useState(false);
    const [errorFlag, setErrorFlag] = useState(false);
    const [autopayStatus, setAutopayStatus] = useState('Disabled');
    const [paymentConfig, setPaymentConfig] = useState([]);
    const [hidePrimarySectionFlag, setHidePrimarySectionFlag] = useState(false);

    //Custodial and Responsible Party Columns
    const modalColumns = [
        {
            name: overViewContent?.overview_case_information_custodial_name,
            email: overViewContent?.overview_case_information_custodial_email,
            phone: overViewContent?.overview_case_information_custodial_phone,
            address: overViewContent?.overview_case_information_custodial_address,
            secondary_phone: overViewContent?.overview_case_information_custodial_sec_phone
        },
        {
            name: overViewContent?.overview_case_information_responsible_name,
            email: overViewContent?.overview_case_information_responsible_email,
            phone: overViewContent?.overview_case_information_responsible_phone,
            address: overViewContent?.overview_case_information_responsible_address,
            secondary_phone: overViewContent?.overview_case_information_responsible_sec_phone
        },
    ]
    //Custodial and Responsible Party Rows
    const modalRows = [
        {
            name_value: caseInfo?.custodial?.custDisplayName,
            email_value: caseInfo?.custodial?.custEmail,
            phone_value: caseInfo?.custodial?.custodial_primary_phone_label !== '' ? caseInfo?.custodial?.custodial_primary_phone_label +" - "+caseInfo?.custodial?.custPhone : caseInfo?.custodial?.custPhone,/* st48236 - INC0288091 - display primary phone type */
            address_value: caseInfo?.custodial?.custAddress,
            secondary_phone_value: caseInfo?.custodial?.custodial_sec_phone_label !== '' ? caseInfo?.custodial?.custodial_sec_phone_label +" - "+caseInfo?.custodial?.custSecondaryPhone : caseInfo?.custodial?.custSecondaryPhone,/* st48236 - INC0288091 - display secondary phone type */
        },
        {
            name_value: caseInfo?.responsible?.respDisplayName,
            email_value: caseInfo?.responsible?.respEmail,
            phone_value: caseInfo?.responsible?.resparty_primary_phone_label !== '' ? caseInfo?.responsible?.resparty_primary_phone_label +" - "+caseInfo?.responsible?.respPhone : caseInfo?.responsible?.respPhone,/* st48236 - INC0288091 - display primary phone type */
            address_value: caseInfo?.responsible?.respAddress,
            secondary_phone_value: caseInfo?.responsible?.resparty_sec_phone_label !== '' ? caseInfo?.responsible?.resparty_sec_phone_label +" - "+caseInfo?.responsible?.respSecondaryPhone : caseInfo?.responsible?.respSecondaryPhone,/* st48236 - INC0288091 - display secondary phone type */
        },
    ]

    const [modalId, setModalId] = useState();

    const [moreAccounts, setMoreAccounts] = useState();

    const headers = {
        "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
        "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
        "X-Hps-Region": Payload?.region,
        "X-Hps-Carrier": Payload?.owning_carrier
    };

    const handleModal = (modal, index) => {
        setModal(modal)
        setModalId(index)
    }

    const handlePayNow = (e) => {
        e.preventDefault();
        if (Cookies.get('owningCarrier') !== 'C4') {
            setPayNow(true);
        }
        // if the carrier is C4 then redirect to fiserv login
        if (Cookies.get('owningCarrier') === 'C4') {
            handleFiservLogin();
        }
    }

    const handleCloseSchedulePaymentModal = (e) => {
        e.preventDefault();
        setPayNow(false);
    }

    const handleAddNew = (e) => {
        e.preventDefault();
        setAddNew(true);
    }

    const handleMoreAccounts = (e) => {
        e.preventDefault();
        handleClose();
        setMoreAccounts(e.currentTarget);
    };

    const handleRemoveAccounts = (e) => {
        e.preventDefault();
        handleClose();
        setRemoveAccounts(e.currentTarget);
    };

    const handleCloseModal = () => {
        setAddNew(false);
    };

    const openRemoveAccounts = Boolean(removeAccounts)
    const openMoreAccounts = Boolean(moreAccounts)

    const baseUrl = process.env.REACT_APP_API_BASE_URL;

    const [showOERenewal, setShowOERenewal] = useState(false);
    const [showMarketPopup, setShowMarketPopup] = useState(false); // PMO0003735 - Show Market Exit Pop up for medical product types during market exit period - st48236
    // st48236 - Show message after payment is done - BA raised request - start
    const [lastPaidDate, setLastPaidDate] = useState('');
    const [checkDueAmt, setCheckDueAmt] = useState(0);
    // st48236 - Show message after payment is done - BA raised request - end
    
    // Handle OE Renewal Popup Display
    const handleCloseOERenewalModal = () => {
       setShowOERenewal(false);
    }

    // Handle Market Exit Popup Display - PMO0003735 - Show Market Exit Pop up for medical product types during market exit period - st48236
    const handleCloseMarketPopup = () => {
        setShowMarketPopup(false);
        let date = new Date();
        date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
        Cookies.set('showMarketExitPopup', 'true', { expires: date, ...getCookieOptions() });
    }

    useEffect(() => {
        if (pageContent?.overview) {
            setOverViewContent(pageContent.overview);
        }

        if (pageContent?.generic) {
            setGenericContent(pageContent.generic);
        }
    }, [pageContent]);

    useEffect(() => {

        // This block is to check and show OE Renewal popup based on cookie and API response applicable only for cigna carrier
        if(Cookies.get('owningCarrier') === process.env.REACT_APP_OE_POPUP_DISPLAY_CARRIER) {
            
            let renewalCookieValue = Cookies.get('showRenewalPopup'); 
            if(renewalCookieValue !== undefined) {
                return; // Do not show the popup if showRenewalPopup is set
            }

            let marketExitCookieValue = Cookies.get('showMarketExitPopup'); // PMO0003735 - Show Market Exit Pop up for medical product types during market exit period - st48236
            if(marketExitCookieValue !== undefined) {
                return; // Do not show the popup if showMarketExitPopup is set
            }
            
            const targetOERenewalUrl = process.env.REACT_APP_API_GET_RENEWAL_STATUS_ENDPOINT;
            getApiService(baseUrl, targetOERenewalUrl, 
                        {  cim: Payload?.cim, 
                           case_num: Payload?.case_num,
                           sitecd: Payload?.site_cd
                        }, 
                            headers
                        )   
            .then((response) => {
                
                if (response?.data && response?.data?.status === 'SUCCESS') {
                    const result = response.data.data;
                    if(result?.showRenewalPopup === true) {
                        setShowOERenewal(true);
                    }
                    // PMO0003735 - Show Market Exit Pop up for medical product types during market exit period - st48236 - start
                    if (result?.showMarketExitPopup === true) {
                        setShowMarketPopup(true);
                    }
                    // PMO0003735 - Show Market Exit Pop up for medical product types during market exit period - st48236 - end
                }else{
                    toast.error(genericContent?.renewal_modal_popup_service_error);
                }
            })
            .catch(error => {
               toast.error(genericContent?.renewal_modal_popup_service_error);
            });
        }

        const targetGetCaseTypesUrl = process.env.REACT_APP_API_CASE_TYPE_DTL_ENDPOINT;
		getApiService(baseUrl, targetGetCaseTypesUrl, { cim: Payload?.cim, case_num: Payload?.case_num, request: '1', "sitecd": Payload?.site_cd }, headers)
			.then((response) => {
				if (response?.data && response?.data?.status === 'SUCCESS') {
					const result = response.data.data;
					Cookies.set('binder_payment_flag', result?.binder_payment_flag, getCookieOptions());
				} 
			})
			.catch(error => {
				toast.error(genericContent?.finance_service_error);
			});

            const paymentType = Cookies.get('binder_payment_flag') === 'true' ? 'BINDER' : 'ONETIME';
    
            const guid = uuidv4();
            const api_headers = {
                "X-Hps-Carrier-Code": Payload?.owning_carrier,
                "X-Hps-Client-Id": process.env.REACT_APP_PAYMENTCONFIG_API_CLIENT_ID,
                "X-Hps-Secret-Id": process.env.REACT_APP_PAYMENTCONFIG_CLIENT_SECRET,
                "X-Hps-Sender-Id": "New Member Portal",
                "X-Hps-Ts": Date.now(),
                "X-Hps-Trace-Id": guid,
                "X-Hps-SiteCd": Payload?.site_cd,
                "Content-Type": "application/json",
                "X-Hps-Db-Region": Payload?.region
            };

            getAPIData(baseUrl, process.env.REACT_APP_API_PAYMENT_CONFIG_ENDPOINT, api_headers).then((result) => {
                if (result.status && result.data && result.status === 200) {
                    //If no AXIOS err

                    let response = result.data;

                    if (!response.error) {
                        //If no API resp error
                        if (response.status_code && response.status_code === "HPS200") {
                            //If API resp success
                            if (response.payment_configurations) {
                                if (response.payment_configurations.payment_preferences) {
                                    const getpaymentPreferenceConfig = () => {
                                        let paymentPreference =
                                            response.payment_configurations.payment_preferences.find(
                                                (pref) => pref.context === paymentType
                                            );
                                        paymentPreference = paymentPreference
                                            ? paymentPreference
                                            : response.payment_configurations.payment_preferences.find(
                                                (pref) => pref.context === "DEFAULT"
                                            );

                                        localStorage.setItem('paymentConfig', JSON.stringify(paymentPreference)); // Store the payment preference in local storage
                                        if (paymentPreference) {
                                            return paymentPreference;
                                        } else {
                                            return [];
                                        }
                                        setApiCallsCompleted(true); // st48236 - 508 compliance Mark API calls as completed 
                                    };
                                    setPaymentConfig(getpaymentPreferenceConfig());
                                }
                            } else {
                                console.log("Payment Config API Failure");
                            }
                        }
                    }
                }
            })
                .catch(error => {
                    console.log("Payment Config API Failure");
                });
        
        const targetRuleValueUrl = process.env.REACT_APP_API_GET_PROGRAM_RULE_VALUE_ENDPOINT;
        getApiService(baseUrl, targetRuleValueUrl, { action: 'ByCarrier', carrierCode: Payload?.owning_carrier }, headers)
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    const result = response.data.data;
                    if (result.length !== 0) {
                        setHidePrimarySectionFlag(result?.HIDE_PRIMARY_ACCOUNT_SECTION);
                        Cookies.set('showafterpaymentmsg',result?.SHOW_AFTER_PAYMENT_MSG ?? false, getCookieOptions()); // st48236 - Show message after payment is done - BA raised request
                        Cookies.set('hidePaymentSection', result?.HIDE_PRIMARY_ACCOUNT_SECTION ?? 'false', getCookieOptions());
                        Cookies.set('fiservTargetUrl', result?.IDP_TARGETS ?? 'false', getCookieOptions());
                        Cookies.set('enableMemPreference', result?.ENABLE_MEMBER_PREFERENCES ?? 'false', getCookieOptions());
                        Cookies.set('enableFiserv', result?.ENABLE_FISERV_WALLET ?? 'false', getCookieOptions());
                    }
                }
            })
            .catch(error => {
                console.log("Get rule value API Failure");
            });

    }, []);

    useEffect(() => {
        //Coverages
        const targetCoverageUrl = process.env.REACT_APP_API_COVERAGE_INFO_ENDPOINT;
        getApiService(baseUrl, targetCoverageUrl, { cim: Payload?.cim }, headers)
            .then((response) => {

                setCoverageLoading(false);
                if (response?.data?.statusCode !== 200) {
                    setCoverageInfoErrorFlag(true);
                } else {
                    const coverageCount = response.data.data.coverages.length;
                    const arrCoverages = response.data.data.coverages;
                    const arrHeaders = [];
                    for (let i = coverageCount; i >= 1; i--) {
                        arrHeaders.push({
                            id: overViewContent?.overview_coverages_case_id_text,
                            plan: overViewContent?.overview_coverages_plan_name_text,
                            coverage: overViewContent?.overview_coverages_coverage_text,
                            product: overViewContent?.overview_coverages_product_type_text,
                            premium: overViewContent?.overview_coverages_premium_text,
                            status: overViewContent?.overview_coverages_status_text,
                            memberId: overViewContent?.overview_coverages_member_id_text,
                            date: overViewContent?.overview_coverages_effective_date_text,
                            termdate: overViewContent?.overview_coverages_term_date_text,
                            dependents: overViewContent?.overview_coverages_name_of_dependents
                        })
                    }
                    // Add dependent click text to each coverage item
                    arrCoverages.forEach((item) => {
                        item['depClick'] = overViewContent?.overview_coverages_dependents_click_review;
                    }
                    );                    
                    setCoverageInfoErrorFlag(false);
                    setCoverageHeader(arrHeaders);
                    setCoverageInfo(arrCoverages);
                    setApiCallsCompleted(true); // st48236 - 508 compliance Mark API calls as completed
                }
            })
            .catch(error => {
                setCoverageLoading(false);
                setCoverageInfoErrorFlag(true);
            });
        }, [overViewContent]);

    //Case Information Api
    useEffect(() => {

        setLoading(true);
        fetchPrimaryAccount(headers);

        const targetCaseAmountUrl = process.env.REACT_APP_API_CASE_BILL_DETAILS_ENDPOINT;
        getApiService(baseUrl, targetCaseAmountUrl, { cim: Payload?.cim }, headers)
            .then((response) => {

                setToPayLoading(false);
                if (response?.data?.statusCode !== 200) {
                    setToPayErrorFlag(true);
                } else {
                    setToPayAmount(response.data.data);
                    setCurrentDueAmount(response.data.data?.current_due_amount || 0);
                    setDueDateDays(response.data.data?.due_date_days || 0);
                    // st48236 - Show message after payment is done - BA raised request - start
                    setLastPaidDate(response.data.data?.last_paid_date || 'N/A');
                    setCheckDueAmt(response.data.data?.check_due_amt || 0);
                    // st48236 - Show message after payment is done - BA raised request - end
                    setToPayErrorFlag(false);
                    setRemoveAccountsModal(true);
                    setAccountsModal(true);
                    setApiCallsCompleted(true); // st48236 - 508 compliance Mark API calls as completed
                }
            })
            .catch(error => {
                setToPayLoading(false);
                setToPayErrorFlag(true);
            });

        const targetCaseUrl = process.env.REACT_APP_API_CASE_INFO_ENDPOINT;
        getApiService(baseUrl, targetCaseUrl, { cim: Payload?.cim }, headers)
            .then((response) => {
                setCaseLoading(false);
                if (response?.data?.statusCode !== 200) {
                    setCaseInfoErrorFlag(true);
                } else {
                    const result = response.data.data;
                    setCaseInfoErrorFlag(false);
                    setCaseInfo(result);
                    setShowSTPS(result?.isSTPSAvailable || false);
                    setShowSTPS2(result?.isSTPS2Available || false);
                    /* PMO0004087 CHG0127827 SD47534 */
                    setShowSTPS3(result?.isSTPS3Available || false);
                    setShowAPTC(result?.isAPTCAvailable || false);
                    Cookies.set('showSTPS', result?.isSTPSAvailable ?? 'false', getCookieOptions());
                    Cookies.set('showSTPS2', result?.isSTPS2Available ?? 'false', getCookieOptions());
                    Cookies.set('showSTPS3', result?.isSTPS3Available ?? 'false', getCookieOptions());
                    Cookies.set('showAPTC', result?.isAPTCAvailable ?? 'false', getCookieOptions());
                    setApiCallsCompleted(true); // st48236 - 508 compliance Mark API calls as completed
                }
            })
            .catch(error => {
                setCaseLoading(false);
                setCaseInfoErrorFlag(true);
            });

        //Agent
        const targetAgentUrl = process.env.REACT_APP_API_AGENT_INFO_ENDPOINT;
        getApiService(baseUrl, targetAgentUrl, { cim: Payload?.cim }, headers)
            .then((response) => {

                setAgentLoading(false);
                if (response?.data?.statusCode !== 200) {
                    setAgentInfoErrorFlag(true);
                } else {
                    const arrAgent = response.data?.data;
                    const agentCount = arrAgent.length;
                    const arrAgentHeaders = [];
                    for (let i = agentCount; i >= 1; i--) {
                        arrAgentHeaders.push({ id: i })
                    }
                    setAgentInfoErrorFlag(false);
                    setAgentHeaders(arrAgentHeaders);
                    setAgentInfo(arrAgent);
                    setApiCallsCompleted(true); // st48236 - 508 compliance Mark API calls as completed
                }
            })
            .catch(error => {
                setAgentLoading(false);
                setAgentInfoErrorFlag(true);
            });

        const targetGetActiveAccountsUrl = process.env.REACT_APP_API_GET_ACTIVE_ACCOUNTS_ENDPOINT;
        getApiService(baseUrl, targetGetActiveAccountsUrl, { cim: Payload?.cim, apiSource: 'count' }, headers)
            .then((response) => {
                if (response?.data && response?.data?.status === 'SUCCESS') {
                    const result = response.data.data;
                    setAccountCount(result);
                    setApiCallsCompleted(true); // st48236 - 508 compliance Mark API calls as completed
                }
            })
            .catch(error => {
                console.error('Error fetching account count data:', error);
            });

        //Autopay status
        const targetGetAutopayStatusUrl = process.env.REACT_APP_API_GET_AUTOPAY_STATUS_ENDPOINT;
        getApiService(baseUrl, targetGetAutopayStatusUrl, { cim: Payload?.cim }, headers)
            .then((response) => {
                if (response?.data?.statusCode !== 200) {
                    setErrorFlag(true);
                } else {
                    setErrorFlag(false);
                    const result = response.data.data;
                    if (result?.autopay_status === 'Y') {
                        setAutopayStatus('Enabled');
                    }
                    setApiCallsCompleted(true); // st48236 - 508 compliance Mark API calls as completed
                }
            })
            .catch(error => {
                setErrorFlag(true);
            });

    }, [Payload?.cim, baseUrl, Payload?.region, Payload?.owning_carrier]);

    function fetchPrimaryAccount(headers) {
        const targetGetPrimaryAccountUrl = process.env.REACT_APP_API_GET_PRIMARY_ACCOUNT_ENDPOINT;
        getApiService(baseUrl, targetGetPrimaryAccountUrl, { cim: Payload?.cim }, headers)
            .then((response) => {
                setLoading(false);
                if (response?.data?.statusCode !== 200) {
                    setPrimaryErrorFlag(true);
                } else {
                    const result = response.data.data;
                    setPrimaryErrorFlag(false);
                    /* st48236 - INC0295110 - avoid display of CCD for BCBSAZ conditions only */
                    let hideBcbsCreditCard = Cookies.get("owningCarrier") === "Q5" && result?.cardType === "CCD" && Cookies.get("binder_payment_flag") !== "true" ? true : false;
                    setHideCCD(hideBcbsCreditCard);
                    /* st48236 - INC0295110 - avoid display of CCD for BCBSAZ conditions only */
                    setPrimaryAccount(result);
                }
            })
            .catch(error => {
                setLoading(false);
                setPrimaryErrorFlag(true);
            });
    }



    const handelViewCoverage = (e) => {
        if (e) {
            return Navigate('/coverage');
        }
    }
	
	/*st48236 - 508 compliance*/      
    // Mark content as ready
    const [userInteracted, setUserInteracted] = useState(false);
        
        useEffect(() => {
          const handleUserInteraction = () => {
            setUserInteracted(true);
          };
        
          // Listen for user interactions
          document.addEventListener('click', handleUserInteraction);
          document.addEventListener('keydown', handleUserInteraction);
          
          return () => {
            document.removeEventListener('click', handleUserInteraction);
            document.removeEventListener('keydown', handleUserInteraction);
          };
        }, []);
        
        useEffect(() => {
          let timeoutId;
          
          if (apiCallsCompleted && !isContentReady) {
            timeoutId = setTimeout(() => {
              // Focus the main element first before setting content as ready
              if (!userInteracted && ref.current) {
                ref.current.focus({ preventScroll: true });
              }
              // Set content ready after focus is established
              setTimeout(() => {
                setContentReady(true);
              }, 100);
            }, parseInt(process.env.REACT_APP_READABILITY_TIMEOUT));
          }
          
          return () => {
            if (timeoutId) clearTimeout(timeoutId);
          };
        }, [apiCallsCompleted, isContentReady, userInteracted]);
    
    /*st48236 - 508 compliance*/

    // Set Active Tab Based on Button Click
    const caseinfoRef = useRef(null);
    const coverageRef = useRef(null);
    const agentRef = useRef(null);
    const billDetailsRef = useRef(null);
    const aptcRef = useRef(null);
    const stpsRef = useRef(null);
    const stps2Ref = useRef(null);
    const stps3Ref = useRef(null); /* PMO0004087 CHG0127827 SD47534*/
    const [tabActiveKey, setTabActiveKey] = useState('case-info');
    const [tableTabActiveKey, setTableTabActiveKey] = useState('');
    
    // Read tab from URL on initial load
    useEffect(() => {
        const tabFromUrl = searchParams.get('tab');
        if (tabFromUrl) {
            // Check if it's a valid table tab key
            const validTableTabs = ['bill-details', 'aptc-info', 'stps-info', 'stps2-info', 'stps3-info']; /* PMO0004087 CHG0127827 SD47534*/
            if (validTableTabs.includes(tabFromUrl) && (tabFromUrl !== 'stps3-info' || showSTPS3)) { /* PMO0004087 CHG0127827 SD47534*/
                setTableTabActiveKey(tabFromUrl);
            }
        }
    }, [searchParams, showSTPS3]); /* PMO0004087 CHG0127827 SD47534*/

    const handleTabClick = (tabKey) => {
        setTabActiveKey(tabKey);
    };
    const handleTableTabClick = (tabKey) => {
        setTableTabActiveKey(tabKey);
        // Update URL when tab changes
        // setSearchParams({ tab: tabKey });
    };
    useEffect(() => {
        if (apiCallsCompleted) {
            let tabRef;
            if (tabActiveKey === "case-info") tabRef = caseinfoRef;
            else if (tabActiveKey === "coverages") tabRef = coverageRef;
            else if (tabActiveKey === "agent") tabRef = agentRef;

            if (tabRef?.current) {
                // Use setTimeout for better timing
                setTimeout(() => {
                    if (tabRef.current) {
                        tabRef.current.focus({ preventScroll: true });
                    }
                }, 100);
            }
        }
    }, [tabActiveKey, apiCallsCompleted]);

    useEffect(() => {
        if (apiCallsCompleted) {
            // Only set default tab if no tab was specified in URL
            if (!tableTabActiveKey) {
                setTableTabActiveKey("bill-details");
            }
            
            let tableRef;
            if (tableTabActiveKey === "bill-details") tableRef = billDetailsRef;
            else if (tableTabActiveKey === "aptc-info") tableRef = aptcRef;
            else if (tableTabActiveKey === "stps-info") tableRef = stpsRef;
            else if (tableTabActiveKey === "stps2-info") tableRef = stps2Ref;
            else if (tableTabActiveKey === "stps3-info") tableRef = stps3Ref; /* PMO0004087 CHG0127827 SD47534*/

            if (tableRef?.current) {
                // Use setTimeout for better timing
                setTimeout(() => {
                    if (tableRef.current) {
                        tableRef.current.focus({ preventScroll: true });
                    }
                }, 100);
            }
        }
    }, [tableTabActiveKey, apiCallsCompleted]);

    return (
        <>
                <main
          role="main"
          tabIndex="-1" // Make the <main> tag focusable
          ref={ref} // Attach the ref to the <main> tag
          style={{ outline: 'none' }} // revmove border
          aria-label={(() => { 
                const carrierName = Cookies.get('carrierName');
                return carrierName ? `${atob(carrierName)} Overview page` : "Overview page";
            })()}
        > {/*st48236 - 508 compliance*/}
            <div>
                <div className="conatiner-fluid content-inner mt-n5 py-0">
                    {apiCallsCompleted && (<AutoRead pageTitle = {genericContent?.sidebar_menu_overview_text || 'Overview'} contentFromExternal={pageContent} />)}
                    <div className="row">
                        <div className="col-md-12 col-lg-4">
                            <div className="row">
                                <div className="col-md-12 col-lg-12">
                                    <div className="card" data-aos="fade-up" data-aos-delay="800" style={{ padding: '0px 10px' }}>
                                        <div className="card-body">
                                            <div id="d-main" className="">
                                                <div className="d-flex col-12 mt-3">
                                                    <div className="col-2 circle-bg text-center lh-lg">
                                                        {/* st48236 - Show message after payment is done - BA raised request - start */}
                                                        <img src={Cookies.get("showafterpaymentmsg") === 'true' && checkDueAmt <= 0 ? lastPaidDate !== 'N/A' ? afterPaidIcon : overViewPayIcon : overViewPayIcon} alt="Payment-Overview" />
                                                    </div>
                                                    {toPayErrorFlag && (
                                                        <div className="api-error-msg">
                                                            {genericContent?.finance_service_error}
                                                        </div>
                                                    )}
                                                    {isToPayLoading && (
                                                        <div style={{ display: '-webkit-inline-box', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
                                                            <Spinner animation="border" role="status" ></Spinner>
                                                            <div style={{ fontSize: "12px" }} aria-hidden="true">{genericContent?.loading_message}</div>
                                                        </div>
                                                    )}
                                                    {(errorFlag || toPayErrorFlag) && (
                                                        <div className="api-error-msg">
                                                            {genericContent?.finance_service_error}
                                                        </div>
                                                    )}
                                                    {!errorFlag && !isToPayLoading && !toPayErrorFlag && toPayAmount && (
                                                        <div className="col-9 overview ms-3">
                                                            <h4 tabIndex={0} className="fw-normal mb-1">{overViewContent?.overview_to_pay}</h4>

                                                            {Payload?.owning_carrier === 'Q5' ? (
                                                                <h2 tabIndex={0} className="mb-2 fw-semibold mt-2 q5-due-amount">{currentDueAmount}</h2>
                                                            ) : (
                                                                <h3 tabIndex={0} className="mb-2 fw-semibold mt-2">{currentDueAmount}</h3>
                                                            )}
                                                            <div className="mt-2">
                                                                {/* st48236 - Show message after payment is done - BA raised request - start */}
                                                                <h6 tabIndex={0} className="mb-3">
                                                                    {Cookies.get("showafterpaymentmsg") === 'true' && checkDueAmt <= 0 ? lastPaidDate !== 'N/A' ? <img src={afterPaidTickIcon} alt="Payment-Done" /> : <i className="fe fe-clock fe-15 me-1 align-middle navy-icon"></i> : <i className="fe fe-clock fe-15 me-1 align-middle navy-icon"></i>}
                                                                {Cookies.get("showafterpaymentmsg") === 'true' && checkDueAmt <= 0 
                                                                    ? (lastPaidDate !== 'N/A' 
                                                                        ? (typeof (overViewContent?.overview_topay_afterpay_text) === 'string' 
                                                                            ? " " + overViewContent?.overview_topay_afterpay_text + " " + lastPaidDate 
                                                                            : 'N/A') 
                                                                        : 'N/A') 
                                                                    : (typeof (overViewContent?.overview_topay_due_days_text) === 'string' && overViewContent?.overview_topay_due_days_text && dueDateDays !== '' 
                                                                        ? (Number(dueDateDays) < 0 
                                                                            ? overViewContent?.overview_topay_pastdue_days_text.replace("%s", Math.abs(dueDateDays)) 
                                                                            : overViewContent?.overview_topay_due_days_text.replace("%s", dueDateDays)) 
                                                                        : 'N/A')}
                                                                </h6>
                                                                {/* st48236 - Show message after payment is done - BA raised request - end */}
                                                                {!readOnlyMode && (
                                                                    <button className="btn btn-primary paynowbutton" onClick={handlePayNow}>{overViewContent?.overview_paynow_button_text}</button>
                                                                )}                                                               
                                                                <h6 tabIndex={0} className="mt-3">
                                                                    {autopayStatus === 'Enabled' ? overViewContent?.overview_autopay_enabled_text : overViewContent?.overview_autopay_disabled_text}
                                                                </h6>                                                               
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        {payNow && (<Modal size='xl' show={payNow} onHide={() => { setPayNow() }} className="schedulepayment">
                                            <Schedulepayment handleCloseSchedulePaymentModal={handleCloseSchedulePaymentModal} />
                                        </Modal>)}
                                        {showOERenewal && (<Modal size='md' show={showOERenewal} 
                                                                     onHide={() => { setShowOERenewal(false) }} 
                                                                     className="oe-renewal-modal">    
                                                <RenewalModal onClose={handleCloseOERenewalModal} />
                                            </Modal>)}
                                        {/* PMO0003735 - Show Market Exit Pop up for medical product types during market exit period - st48236 - start */}
                                        {showMarketPopup && (
                                            <Modal size='md' show={showMarketPopup} onHide={handleCloseMarketPopup} className="market-exit-modal">
                                                <MarketExitModal onClose={handleCloseMarketPopup} />
                                            </Modal>
                                        )}
                                         {/* PMO0003735 - Show Market Exit Pop up for medical product types during market exit period - st48236 - end */}
                                    </div>
                                {!hidePrimarySectionFlag && (
                                        <div>
                                            <div className="col-12 d-flex wallet mt-4" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'nowrap', gap: '5px'  }}>
                                                <div tabIndex={Payload?.owning_carrier === 'C4' ? -1 : 0} className="d-flex align-items-center" style={{ flex: '0 1 auto', minWidth: '0' }}>
                                                    <img src={wallet} alt="wallet" />
                                                    <label className="ms-1 wallet mb-0">
                                                        {overViewContent?.overview_wallet}
                                                        {Payload?.owning_carrier !== 'Q5' && (
                                                            <img src={chevron} alt="chevron" />
                                                        )}
                                                    </label>
                                                </div>
                                                {!readOnlyMode && (
                                                <div className="d-flex align-items-center text-end mt-1" style={{ flex: '0 0 auto', gap: '5px' }}>
                                                    <Button variant="link" className="addnewbutton" onClick={handleAddNew} tabIndex={Payload?.owning_carrier === 'C4' ? -1 : 0}>
                                                        {overViewContent?.overview_wallet_add_new}
                                                    </Button>
                                                    {addNew && (<Modal size='xl' show={addNew} onHide={() => { setAddNew() }} >
                                                        <Forms handleCloseModal={handleCloseModal} sendDataToParent={handleDataFromModal} />
                                                    </Modal>)}
                                                        {/* {(accountCount?.NumOfAccounts > 0) && ( */}
                                                    <div style={{ position: 'relative', display: 'inline-block' }}>
                                                            <button
                                                                id="example"
                                                                type="button"
                                                                aria-label="Add more items"
                                                                className="three-dots-button"
                                                                ref={buttonRef}
                                                                onClick={handleToggle}
                                                                tabIndex={Payload?.owning_carrier === 'C4' ? -1 : 0}
                                                            >
                                                                <img
                                                                    src={addmore}
                                                                    alt="More options"
                                                                    className="three-dots-icon align-text-bottom"
                                                                    // aria-hidden="true" // st48236 - first give enter mark to open popup
                                                                />
                                                            </button>

                                                            {show && (
                                                                <div
                                                                    className="custom-dropdown-menu"
                                                                    ref={dropdownRef}
                                                                >
                                                                    <div className="dropdown-arrow"></div>
                                                                    <ul className="dropdown-list">
                                                                        <li className="dropdown-item">
                                                                            <button
                                                                                type="button"
                                                                                onClick={handleMoreAccounts}
                                                                                className="dropdown-button"
                                                                                tabIndex={Payload?.owning_carrier === 'C4' ? -1 : 0}
                                                                            >
                                                                                <img
                                                                                    src={changePrimaryIcon}
                                                                                    alt="More accounts"
                                                                                    style={{ width: '16px', height: '16px' }}
                                                                                />
                                                                                <span>{overViewContent?.overview_wallet_more_acc}</span>
                                                                            </button>
                                                                        </li>
                                                                        <li className="dropdown-item">
                                                                            <button
                                                                                type="button"
                                                                                onClick={handleRemoveAccounts}
                                                                                className="dropdown-button"
                                                                                tabIndex={Payload?.owning_carrier === 'C4' ? -1 : 0}
                                                                            >
                                                                                <img
                                                                                    src={trashIcon}
                                                                                    alt="Remove accounts"
                                                                                    style={{ width: '16px', height: '16px' }}
                                                                                />
                                                                                <span>{overViewContent?.overview_wallet_remove_acc}</span>
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {/* )} */}
                                                        <Modal size="lg" show={openMoreAccounts} onHide={() => { setMoreAccounts() }}>
                                                            <MultipleAccounts accountsModal={accountsModal} sendDataToOverview={handleDataFromModal} />
                                                        </Modal>
                                                        <Modal size="lg" show={openRemoveAccounts} onHide={() => { setRemoveAccounts() }}>
                                                            <RemoveAccounts activeModal={activeModal} />
                                                        </Modal>
                                                    </div>
                                                )}
                                                </div>
                                                        
                                                <div className="position-relative">

                                                {primaryErrorFlag && (
                                                    <div className="api-error-msg">
                                                        {genericContent?.finance_service_error}
                                                    </div>
                                                )}
                                                {isLoading && (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
                                                        <Spinner animation="border" role="status" ></Spinner>
                                                        <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                                                    </div>
                                                )}
                                                {!isLoading && !primaryErrorFlag && (primaryAccount) && (
                                                    <div className="payment-card px-3 py-2 mt-2">
                                                        {/* st48236 - INC0295110 - avoid display of CCD for BCBSAZ conditions only */}
                                                        {(primaryAccount?.primaryActive === 'Y' && !isHideCCD) ?
                                                            <div tabIndex={0}>
                                                                <div className="d-flex mb-2 mt-2">
                                                                    <label className="text-white col-6">{(primaryAccount?.MainAccountType === 'EFT') ? overViewContent?.overview_primary_account_name_text : overViewContent?.overview_wallet_card_holder_name}</label>
                                                                    <label className="text-white text-end fw-light col-6">
                                                                        {(primaryAccount?.MainAccountType !== 'EFT') && (
                                                                            <img src={creditcard}
                                                                                className="align-text-bottom" alt="creditcard" />
                                                                        )}
                                                                        <span> {overViewContent?.overview_wallet_primary_acc}</span>
                                                                    </label>
                                                                </div>
                                                                <div className="mb-1">
                                                                    <h3 className="text-white fw-normal">{primaryAccount?.AccountName}</h3>
                                                                </div>
                                                                <div className="mb-2">
                                                                    <h5 className="text-white fw-normal"><span style={{ fontSize: '13px' }}>{(primaryAccount?.MainAccountType === 'EFT') ? overViewContent?.overview_primary_account_acc_no_ending_text : '**** **** **** '}</span> {primaryAccount?.AccountNumLastFour}</h5>
                                                                </div>
                                                                <div className="mb-1">
                                                                    <h6 className="text-white">
                                                                        {(primaryAccount?.MainAccountType === 'EFT') ? (genericContent?.[
                                                "account_type_" +
                                                primaryAccount?.AccountType.toLowerCase()
                                              ] || primaryAccount?.AccountType) : overViewContent?.overview_wallet_valid_thru}</h6>
                                                                </div>

                                                                <div className="d-flex mb-3 mt-2 justify-content-end">
                                                                    {primaryAccount?.MainAccountType !== 'EFT' &&
                                                                        <label className="text-white col-9">{primaryAccount?.ExpiryDate}</label>
                                                                    }
                                                                    {(primaryAccount?.AccountType === 'VISA') && (
                                                                        <img src={visa} className="text-end col-3"
                                                                            height="24" width="50" alt="visa card" />
                                                                    )}
                                                                    {(primaryAccount?.AccountType === 'MC') && (
                                                                        <img src={mastercard} className="text-end col-3"
                                                                            height="32" width="32" alt="mastercard" />
                                                                    )}
                                                                    {(primaryAccount?.MainAccountType === 'EFT') && (
                                                                        <img src={bank} className="text-end col-3"
                                                                            height="32" width="32" alt="bank account" />
                                                                    )}
                                                                </div>
                                                            </div>
                                                            : <div style={{ fontSize: '13px', color: '#ffffff', padding: '5px' }}>{overViewContent?.overview_primary_account_nodata_text}</div>
                                                        }
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-8 overviewtabcard">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card" data-aos="fade-up" data-aos-delay="800">

                                        <div className="card-body">
                                            {/* Mobile Dropdown for Q5 Carrier */}
                                            {Payload?.owning_carrier === 'Q5' && (
                                                <div className="d-block d-md-none w-100 mb-3">
                                                    {/* <label 
                                                        htmlFor="overview-tab-select"
                                                        className="q5-payment-type-label"
                                                        id="overview-tab-select-label"
                                                    >
                                                        Select View
                                                    </label> */}
                                                    <Form.Select 
                                                        id="overview-tab-select"
                                                        value={tabActiveKey} 
                                                        onChange={(e) => handleTabClick(e.target.value)}
                                                        aria-label="Select view option to display case information, coverages, or agent details"
                                                        aria-describedby="overview-tab-description"
                                                        className="payment-type-select"
                                                        tabIndex={0}
                                                    >
                                                        <option value="case-info">
                                                            {overViewContent?.overview_case_info_tab_title || 'Case Info'}
                                                        </option>
                                                        <option value="coverages">
                                                            {overViewContent?.overview_coverages_tab_title || 'Coverages'}
                                                        </option>
                                                        <option value="agent">
                                                            {overViewContent?.overview_agent_tab_title || 'Agent'}
                                                        </option>
                                                    </Form.Select>
                                                    <span id="overview-tab-description" className="sr-only visually-hidden">
                                                        Use this dropdown to switch between different views of your overview information
                                                    </span>
                                                </div>
                                            )}

                                            {/* Tab Navigation (Hidden on mobile for Q5, Always shown for other carriers) */}
                                            <div className={`nav nav-tabs ${Payload?.owning_carrier === 'Q5' ? 'd-none d-md-flex' : ''}`} id="nav-tab" role="tablist" aria-label="Overview information tabs">
                                                <button className={`nav-link ${tabActiveKey === 'case-info' ? 'active' : ''} me-xl-3`} id="nav-caseinfo-tab"
                                                    data-bs-toggle="tab" data-bs-target="#nav-caseinfo" type="button"
                                                    role="tab" aria-controls="nav-caseinfo" aria-selected={tabActiveKey === 'case-info'}
                                                    onClick={() => handleTabClick('case-info')} onKeyDown={(e) => {
                                                        if (e.key === 'ArrowRight') {
                                                          e.preventDefault();
                                                          document.getElementById('nav-coverages-tab')?.focus();
                                                        }
                                                      }}>
                                                    <span class="">{overViewContent?.overview_case_info_tab_title}</span>
                                                </button>
                                                <button className={`nav-link ${tabActiveKey === 'coverages' ? 'active' : ''} me-xl-3`} id="nav-coverages-tab" data-bs-toggle="tab"
                                                    data-bs-target="#nav-coverages" type="button" role="tab"
                                                    aria-controls="nav-coverages" aria-selected={tabActiveKey === 'coverages'}
                                                    onClick={() => handleTabClick('coverages')} onKeyDown={(e) => {
                                                        if (e.key === 'ArrowLeft') {
                                                          e.preventDefault();
                                                          document.getElementById('nav-caseinfo-tab')?.focus();
                                                        } else if (e.key === 'ArrowRight') {
                                                          e.preventDefault();
                                                          document.getElementById('nav-agent-tab')?.focus();
                                                        }
                                                      }}>
                                                    <span
                                                    class="">{overViewContent?.overview_coverages_tab_title}</span>                                                      
                                                </button>
                                                <button className={`nav-link ${tabActiveKey === 'agent' ? 'active' : ''} me-xl-3`} id="nav-agent-tab" data-bs-toggle="tab"
                                                    data-bs-target="#nav-agent" type="button" role="tab"
                                                    aria-controls="nav-agent" aria-selected={tabActiveKey === 'agent'}
                                                    onClick={() => handleTabClick('agent')} onKeyDown={(e) => {
                                                        if (e.key === 'ArrowLeft') {
                                                          e.preventDefault();
                                                          document.getElementById('nav-coverages-tab')?.focus();
                                                        }
                                                      }}>
                                                    <span class="">{overViewContent?.overview_agent_tab_title}</span>
                                                </button>
                                            </div>
                                            <div class="tab-content nav-billings" id="nav-tabContent">
                                                {tabActiveKey === "case-info" && (
                                                <div
                                                ref={caseinfoRef}
                                                style={{ outline: 'none' }}
                                                className="tab-pane fade show active"
                                                id="nav-caseinfo"
                                                role="tabpanel"
                                                aria-labelledby="nav-caseinfo-tab"
                                                aria-label={overViewContent?.overview_case_info_tab_title}
                                                onKeyDown={(e) => {
                                                        // Handle Shift+Tab to go back to tabs
                                                        if (e.key === 'case-info' && e.shiftKey) {
                                                        e.preventDefault();
                                                        document.getElementById('nav-caseinfo-tab')?.focus();
                                                        }
                                                    }}
                                                >
                                                    {isCaseLoading && (
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
                                                            <Spinner animation="border" role="status" ></Spinner>
                                                            <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                                                        </div>
                                                    )}
                                                    {caseInfoErrorFlag && (
                                                        <div tabIndex={0} className="api-error-msg">
                                                            {genericContent?.case_info_service_error}
                                                        </div>
                                                    )}
                                                    {!isCaseLoading && !caseInfoErrorFlag && caseInfo && (
                                                        <div className="tab-pane fade show active" id="nav-caseinfo" role="tabpanel"
                                                            aria-labelledby="nav-caseinfo-tab">
                                                            <div className="d-xl-flex d-md-flex mt-4">
                                                                <div className="col-xl-2 me-2 col-md-2">
                                                                    <button
                                                                        className={`align-items-center avatar-50 user-circle nav-link${Payload?.owning_carrier === 'Q5' ? ' no-hover' : ''}`}
                                                                        type="button"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                         tabIndex={-1}
                                                                    >
                                                                        {caseInfo?.profileName}
                                                                    </button>
                                                                </div>
                                                                <div className="col-xl-10 col-md-10 mt-2 mt-xl-0">
                                                                    <div className="mb-2 d-xl-block d-md-block d-sm-block d-block">
                                                                        <div className="col-xl-12 d-xl-flex d-md-flex mb-4 d-flex">
                                                                            <div tabIndex={0} className="col-4 labels">
                                                                                <label className="label-heading">{overViewContent?.overview_case_information_name}</label>
                                                                                <label className="label-name fw-medium">{caseInfo?.displayName}</label>
                                                                            </div>
                                                                            <div tabIndex={0} className="col-4 labels">
                                                                                <label className="label-heading">{overViewContent?.overview_case_information_memberid}</label>
                                                                                <label className="label-name fw-medium"> {caseInfo?.carrierSubId}</label>
                                                                            </div>
                                                                            <div tabIndex={0} className="col-4 labels">
                                                                                <label className="label-heading">{overViewContent?.overview_case_information_policy_status}</label>
                                                                                <label className="label-name fw-medium"> {caseInfo?.caseStatus}</label>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-xl-12 d-xl-flex d-md-flex d-flex mb-4">
                                                                            {/* <div className="col-4 labels">
                                                                    <label className="label-heading">Type</label>
                                                                    <label className="label-name fw-medium">
                                                                        Dental
                                                                    </label>
                                                                </div> */}
                                                                            <div tabIndex={0} className="col-8 labels">
                                                                                <label className="label-heading">{overViewContent?.overview_case_information_mailling_address}</label>
                                                                                {/* <label className="label-name fw-medium"> {caseInfo?.mailAddress}</label> */}
                                                                                <div className="label-name fw-medium">
                                                                                    {/* {caseInfo?.mailAddress?.split(',').map((part, index) => (
                                                                                        <div key={index}>{part.trim()}</div>
                                                                                    ))} */}
                                                                                    <label>{caseInfo?.mailAddress}</label>
                                                                                </div>
                                                                            </div>
                                                                            <div tabIndex={0} className="col-4 labels">
                                                                                <label className="label-heading">{overViewContent?.overview_case_information_dob}</label>
                                                                                <label className="label-name fw-medium"> {caseInfo?.DoB}</label>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-xl-12 d-xl-flex d-md-flex d-flex mb-4">
                                                                            <div tabIndex={0} className="col-4 labels">
                                                                                <label className="label-heading">{overViewContent?.overview_case_information_effective_date}</label>
                                                                                <label className="label-name fw-medium"> {caseInfo?.effectiveDt}</label>
                                                                            </div>
                                                                            {/* <div className="col-4 labels">
                                                                    <label className="label-heading">{overViewContent?.overview_case_information_dob}</label>
                                                                    <label className="label-name fw-medium"> {caseInfo?.DoB}</label>
                                                                </div> */}
                                                                            {/* <div className="col-4 labels">
                                                                    <label className="label-heading">{overViewContent?.overview_case_information_effective_date}</label>
                                                                    <label className="label-name fw-medium"> {caseInfo?.effectiveDt}</label>
                                                                </div> */}
                                                                            {/* st48236 - INC0288091 - display secondary phone number - start */}
                                                                            <div tabIndex={0} className="col-4 labels">
                                                                                <label className="label-heading">{overViewContent?.overview_case_information_phone}</label>
                                                                                <label className="label-name fw-medium">{(caseInfo?.phoneNumber !== 'N/A')} {caseInfo?.phoneTypeLabel && caseInfo?.phoneTypeLabel !== '' ? caseInfo?.phoneTypeLabel +" - "+caseInfo?.phoneNumber : caseInfo?.phoneNumber}</label>
                                                                            </div>
                                                                            
                                                                            <div tabIndex={0} className="col-4 labels">
                                                                                <label className="label-heading">{overViewContent?.sec_phone_lbl}</label>
                                                                                <label className="label-name fw-medium">{(caseInfo?.secondaryphone !== 'N/A')} {caseInfo?.secondaryPhoneTypeLabel && caseInfo?.secondaryPhoneTypeLabel !== '' ? caseInfo?.secondaryPhoneTypeLabel +" - "+caseInfo?.secondaryphone : caseInfo?.secondaryphone}</label>
                                                                            </div>
                                                                            {/* st48236 - INC0288091 - display secondary phone number - end */}
                                                                        </div>
                                                                        <div className="col-xl-12 d-xl-flex d-md-flex d-flex mb-4">
                                                                            <div className="col-xl-4 labels col-sm-4 col-6">
                                                                                <label className="label-heading">{overViewContent?.overview_case_information_custodial}</label>
                                                                                <button
                                                                                    className="btn btns btn-outline-primary btnviewdetails"
                                                                                    aria-label ="Custodial View Details" //st48236 - 508 compliance
                                                                                    onClick={() => handleModal(overViewContent?.overview_case_information_custodial, 0)}>
                                                                                    {overViewContent?.overview_case_information_view_more}
                                                                                    {Payload?.owning_carrier !== 'Q5' && (
                                                                                        <img src={viewIcon} className="ms-1" alt="view" />
                                                                                    )}
                                                                                </button>
                                                                            </div>
                                                                            <div className="col-xl-4 col-sm-4 col-6 labels">
                                                                                <label className="label-heading">{overViewContent?.overview_case_information_responsible}</label>
                                                                                <button
                                                                                    className="btn btns btn-outline-primary btnviewdetails"
                                                                                    aria-label ="Responsible Party View Details"  //st48236 - 508 compliance
                                                                                    onClick={() => handleModal(overViewContent?.overview_case_information_responsible, 1)}
                                                                                >
                                                                                    {overViewContent?.overview_case_information_view_more}
                                                                                    {Payload?.owning_carrier !== 'Q5' && (
                                                                                        <img src={viewIcon} className="ms-1" alt="view" />
                                                                                    )}
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>

                                                        </div>
                                                    )}
                                                </div>
                                                )}
                                                {tabActiveKey === "coverages" && (
                                                <div
                                                ref={coverageRef}
                                                tabIndex={0}
                                                style={{ outline: 'none' }}
                                                className="tab-pane fade show active"
                                                id="nav-coverages"
                                                role="tabpanel"
                                                aria-labelledby="nav-coverages-tab"
                                                aria-label={overViewContent?.overview_coverages_tab_title}
                                                onKeyDown={(e) => {
                                                        // Handle Shift+Tab to go back to tabs
                                                        if (e.key === 'coverages' && e.shiftKey) {
                                                        e.preventDefault();
                                                        document.getElementById('nav-coverages-tab')?.focus();
                                                        }
                                                    }}
                                                >
                                                    {coverageInfoErrorFlag && (
                                                        <div className="api-error-msg">
                                                            {genericContent?.coverage_info_service_error}
                                                        </div>
                                                    )}
                                                    {isCoverageLoading && (
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
                                                            <Spinner animation="border" role="status" ></Spinner>
                                                            <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                                                        </div>
                                                    )}

                                                    {!isCoverageLoading && !coverageInfoErrorFlag && coverageInfo && (
                                                        <div className="tab-pane fade show" id="nav-coverages" role="tabpanel"
                                                            aria-labelledby="nav-coverages-tab">
                                                            <div className="col-12 mt-3">
                                                                <div className="">
                                                                    <h6 tabIndex={0} className="mb-3 mt-3">
                                                                        <i className="fe fe-file-text fe-15 me-1"></i>
                                                                        {typeof (overViewContent?.overview_coverages_total_product_text) === 'string' && overViewContent?.overview_coverages_total_product_text ? overViewContent?.overview_coverages_total_product_text.replace("%s", coverageInfo?.length) : ''}{coverageInfo?.length > 1 ? 's' : ''} {overViewContent?.overview_coverages_enrolled_text}
                                                                    </h6>
                                                                    {coverageHeader?.map((item, index) => (
                                                                        <TableCard
                                                                            key={index}
                                                                            columns={item}
                                                                            rows={coverageInfo[index]}
                                                                            label={overViewContent}
                                                                            eventKey={String(index)}
                                                                            activeKey={activeKey}
                                                                            setActiveKey={setActiveKey}
                                                                            variant="overview"
                                                                            aria-label="Coverage details table"
                                                                            tabIndex={0} />
                                                                    ))}

                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                )}
                                                {tabActiveKey === "agent" && (
                                                <div
                                                ref={agentRef}
                                                tabIndex={0}
                                                style={{ outline: 'none' }}
                                                className="tab-pane fade show active"
                                                id="nav-agent"
                                                role="tabpanel"
                                                aria-labelledby="nav-agent-tab"
                                                aria-label={overViewContent?.overview_agent_tab_title}
                                                onKeyDown={(e) => {
                                                        // Handle Shift+Tab to go back to tabs
                                                        if (e.key === 'agent' && e.shiftKey) {
                                                        e.preventDefault();
                                                        document.getElementById('nav-agent-tab')?.focus();
                                                        }
                                                    }}
                                                >
                                                    {agentInfoErrorFlag && (
                                                        <div className="api-error-msg">
                                                            {genericContent?.agent_info_service_error}
                                                        </div>
                                                    )}
                                                    {isAgentLoading && (
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
                                                            <Spinner animation="border" role="status" ></Spinner>
                                                            <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                                                        </div>
                                                    )}
                                                    {!isAgentLoading && !agentInfoErrorFlag && agentInfo.length > 0 ? (
                                                        <Carousel
                                                            prevIcon={
                                                                owningCarrier === 'Q5' && agentHeaders.length <= 1
                                                                    ? null
                                                                    : <img src={previousarrow} alt="previous" />
                                                            }
                                                            nextIcon={
                                                                owningCarrier === 'Q5' && agentHeaders.length <= 1
                                                                    ? null
                                                                    : <img src={nextarrow} alt="nextarrow" />
                                                            }
                                                            indicators={false}
                                                            interval={null}
                                                            className={`agent-carousel${owningCarrier === 'Q5' && agentHeaders.length <= 1 ? ' no-arrows' : ''}`}
                                                        >
                                                            {agentHeaders?.map((item, index) => (
                                                                <Carousel.Item key={index}>
                                                                    <AgentTable
                                                                        columns={overViewContent}
                                                                        rows={agentInfo[index]}
                                                                        eventKey={index.toString()}
                                                                    />
                                                                </Carousel.Item>
                                                            ))}
                                                        </Carousel>
                                                    ) :
                                                        (<div className="labels"><p className="lh-base">{overViewContent?.overview_agent_no_data_text}</p></div>)
                                                    }
                                                </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="p-2 tabular">
                                            {coverageInfoErrorFlag && (
                                                <div className="api-error-msg">
                                                    {genericContent?.coverage_info_service_error}
                                                </div>
                                            )}
                                            {isCoverageLoading && (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
                                                    <Spinner animation="border" role="status" ></Spinner>
                                                    <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                                                </div>
                                            )}

                                            {!isCoverageLoading && coverageInfo && (
                                                <Carousel
                                                    interval={null}
                                                    controls={false}
                                                    indicators={Payload?.owning_carrier === 'Q5' ? (coverageInfo?.length > 1) : true}
                                                    prevIcon={null}
                                                    nextIcon={null}
                                                    className="coverage-carousel"
                                                >
                                                    {coverageInfo?.map((item) => (
                                                        <Carousel.Item>
                                                            <div className="table-responsive coverage-table">
                                                                <table tabIndex={0} className="table table-striped table-light white-rows">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col"><img src={ healthPlanIcon } alt="healthplan" />
                                                                            </th>
                                                                            <th scope="col" className="">
                                                                                <label className="d-block">{item?.prodType + '-' + item?.caseId}</label>
                                                                                <label className="d-block">
                                                                                    {Payload?.owning_carrier === 'Q5' ? (
                                                                                    <span className={item?.dtlCaseStatus === 'Termed' ? 'text-primary fw-bold' : 'text-success'}>
                                                                                        {item?.dtlCaseStatus}
                                                                                    </span>)
                                                                                    : <button className={`btn btn-sm casestatus ${getStatusClass(item?.dtlCaseStatus)}`}>
                                                                                    {item?.dtlCaseStatus}
                                                                                    </button>}
                                                                                </label>
                                                                            </th>
                                                                            <th scope="col">
                                                                                <label className="d-block">{overViewContent?.overview_coverages_plan_name_text}</label>
                                                                                <label className="d-block">
                                                                                    {item?.planName}
                                                                                </label>
                                                                            </th>
                                                                            <th scope="col">
                                                                                <label className="d-block">{overViewContent?.overview_coverages_plan_id_text}</label>
                                                                                <label className="d-block"> {item?.planId}</label>
                                                                            </th>
                                                                            <th scope="col">
                                                                                <label className="d-block">{overViewContent?.overview_coverages_premium_text}</label>
                                                                                <label className="d-block"> {item?.premiumAmt}</label>
                                                                            </th>
                                                                            <th scope="col">
                                                                                <label className="d-block">{overViewContent?.overview_coverages_due_date_text}</label>
                                                                                <label className="d-block">{caseInfo?.dueDate}</label>
                                                                            </th>
                                                                            <th scope="col">
                                                                                <button
                                                                                    className={`btn btn-view ${Payload?.owning_carrier === 'Q5' ? 'btn-outline-secondary' : 'btn-primary'}`}
                                                                                    onClick={() => handelViewCoverage(true)}
                                                                                >
                                                                                    {overViewContent?.overview_coverages_view}
                                                                                </button>
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                </table>
                                                            </div>
                                                        </Carousel.Item>
                                                    ))}
                                                </Carousel>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 mt-4">
                            {/* Mobile Dropdown for Q5 Carrier - Billing Tabs */}
                            {Payload?.owning_carrier === 'Q5' && (
                                <div className="d-block d-md-none w-100 mb-3">
                                    {/* <label 
                                        htmlFor="billing-tab-select"
                                        className="q5-payment-type-label"
                                        id="billing-tab-select-label"
                                    >
                                        Select Section
                                    </label> */}
                                    <Form.Select 
                                        id="billing-tab-select"
                                        value={tableTabActiveKey} 
                                        onChange={(e) => handleTableTabClick(e.target.value)}
                                        aria-label="Select section to view billing details, APTC, or STPS information"
                                        aria-describedby="billing-tab-description"
                                        className="payment-type-select"
                                        tabIndex={0}
                                    >
                                        <option value="bill-details">
                                            {overViewContent?.overview_recent_billing_title}
                                        </option>
                                        {showAPTC && (
                                            <option value="aptc-info">
                                                {overViewContent?.overview_aptc_title}
                                            </option>
                                        )}
                                        {showSTPS && (
                                            <option value="stps-info">
                                                {overViewContent?.overview_stps_title}
                                            </option>
                                        )}
                                        {showSTPS2 && (
                                            <option value="stps2-info">
                                                {overViewContent?.overview_stps2_title}
                                            </option>
                                        )}
                                        {/* PMO0004087 CHG0127827 SD47534 */}
                                        {showSTPS3 && (
                                            <option value="stps3-info">
                                                {overViewContent?.overview_stps3_title || 'STPS3'}
                                            </option>
                                        )}
                                    </Form.Select>
                                    <span id="billing-tab-description" className="sr-only visually-hidden">
                                        Use this dropdown to switch between different billing and subsidy information
                                    </span>
                                </div>
                            )}

                            {/* Tab Navigation (Hidden on mobile for Q5, Always shown for other carriers) */}
                            <div className={`nav nav-tabs ${Payload?.owning_carrier === 'Q5' ? 'd-none d-md-flex' : ''}`} id="nav-tab" role="tablist" aria-label="Billing information tabs">
                                <button className={`nav-link ${tableTabActiveKey === 'bill-details' ? 'active' : ''} me-xl-3`} id="nav-rbill-tab" data-bs-toggle="tab"
                                    data-bs-target="#nav-rbill" type="button" role="tab" tabIndex={0}
                                    aria-controls="nav-rbill" aria-selected={tableTabActiveKey === 'bill-details'}
                                    onClick={() => handleTableTabClick('bill-details')} onKeyDown={(e) => {
                                        console.log('Key pressed:', e.key);
                                        if (e.key === 'ArrowRight') {
                                            e.preventDefault();
                                            document.getElementById('nav-aptc-tab')?.focus();
                                        }
                                }}>
                                    <span class="">{overViewContent?.overview_recent_billing_title}</span>
                                </button>
                                {showAPTC && (
                                    <button className={`nav-link ${tableTabActiveKey === 'aptc-info' ? 'active' : ''} me-xl-3`} id="nav-aptc-tab" data-bs-toggle="tab"
                                        data-bs-target="#nav-aptc" type="button" role="tab" tabIndex={0}
                                        aria-controls="nav-aptc" aria-selected={tableTabActiveKey === 'aptc-info'}
                                        onClick={() => handleTableTabClick('aptc-info')} onKeyDown={(ae) => {
                                            console.log('Key pressedaptc:', ae.key);
                                            if (ae.key === 'ArrowLeft') {
                                                ae.preventDefault();
                                                document.getElementById('nav-rbill-tab')?.focus();
                                            }else if (ae.key === 'ArrowRight') {
                                                ae.preventDefault();
                                                document.getElementById('nav-stps-tab')?.focus();
                                            }
                                    }}>
                                        <span class="">{overViewContent?.overview_aptc_title}</span>
                                    </button>
                                )}
                                {showSTPS && (
                                    <button className={`nav-link ${tableTabActiveKey === 'stps-info' ? 'active' : ''} me-xl-3`} id="nav-stps-tab" data-bs-toggle="tab"
                                        data-bs-target="#nav-stps" type="button" role="tab" tabIndex={0}
                                        aria-controls="nav-stps" aria-selected={tableTabActiveKey === 'stps-info'}
                                        onClick={() => handleTableTabClick('stps-info')} onKeyDown={(se) => {
                                            console.log('Key pressedstps:', se.key);
                                            if (se.key === 'ArrowLeft') {
                                                se.preventDefault();
                                                const rbilElement = document.getElementById('nav-rbill-tab');
                                                if (rbilElement) {
                                                    rbilElement.focus();
                                                }
                                                const aptcElement = document.getElementById('nav-aptc-tab');
                                                if (aptcElement) {
                                                    aptcElement.focus();
                                                }
                                            } else if (se.key === 'ArrowRight') {
                                                se.preventDefault();
                                                const stps2Element = document.getElementById('nav-stps2-tab');
                                                if (stps2Element) {
                                                    stps2Element.focus();
                                                }
                                            }
                                    }}>
                                        <span class="">{overViewContent?.overview_stps_title}</span>
                                    </button>
                                )}
                                { showSTPS2 && (
                                    <button className={`nav-link ${tableTabActiveKey === 'stps2-info' ? 'active' : ''} me-xl-3`} id="nav-stps2-tab" data-bs-toggle="tab"
                                        data-bs-target="#nav-stps2" type="button" role="tab" tabIndex={0}
                                        aria-controls="nav-stps2" aria-selected={tableTabActiveKey === 'stps2-info'}
                                        onClick={() => handleTableTabClick('stps2-info')} onKeyDown={(ste) => {
                                            if (ste.key === 'ArrowLeft') {
                                                ste.preventDefault();
                                                const aptcelement = document.getElementById('nav-aptc-tab');
                                                if (aptcelement) {
                                                    document.getElementById('nav-aptc-tab')?.focus();
                                                }
                                                const rbilelement = document.getElementById('nav-rbill-tab');
                                                if (rbilelement) {
                                                    document.getElementById('nav-rbill-tab')?.focus();
                                                }
                                                const stpselement = document.getElementById('nav-stps-tab');
                                                if (stpselement) {
                                                    document.getElementById('nav-stps-tab')?.focus();
                                                }
                                            } else if (ste.key === 'ArrowRight' && showSTPS3) {
                                                ste.preventDefault();
                                                document.getElementById('nav-stps3-tab')?.focus();
                                            }
                                            }}>
                                        <span class="">{overViewContent?.overview_stps2_title}</span>
                                    </button>
                                )}
                                {/* PMO0004087 CHG0127827 SD47534 */}
                                {showSTPS3 && (
                                    <button className={`nav-link ${tableTabActiveKey === 'stps3-info' ? 'active' : ''} me-xl-3`} id="nav-stps3-tab" data-bs-toggle="tab"
                                        data-bs-target="#nav-stps3" type="button" role="tab" tabIndex={0}
                                        aria-controls="nav-stps3" aria-selected={tableTabActiveKey === 'stps3-info'}
                                        onClick={() => handleTableTabClick('stps3-info')} onKeyDown={(event) => {
                                            if (event.key === 'ArrowLeft') {
                                                event.preventDefault();
                                                const previousTabId = showSTPS2 ? 'nav-stps2-tab' : showSTPS ? 'nav-stps-tab' : showAPTC ? 'nav-aptc-tab' : 'nav-rbill-tab';
                                                document.getElementById(previousTabId)?.focus();
                                            }
                                        }}>
                                        <span className="">{overViewContent?.overview_stps3_title || 'STPS3'}</span>
                                    </button>
                                )} {/* PMO0004087 CHG0127827 SD47534*/}
                            </div>
                                {apiCallsCompleted && tableTabActiveKey === 'bill-details' && (
                                    <div className="card mt-4">
                                        <div className="card-body p-2">
                                            <div 
                                            ref={billDetailsRef}
                                            style={{ outline: 'none' }}
                                            className="tab-pane fade show active" id="nav-rbill" role="tabpanel"
                                                aria-labelledby="nav-rbill-tab"
                                                aria-label={overViewContent?.overview_recent_billing_title}
                                                aria-live="polite">
                                                    {isContentReady && <RecentBilling />}
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {tableTabActiveKey === 'aptc-info' &&  (                               
                                    <div className="card mt-4">
                                        <div className="card-body p-2">
                                            <div 
                                            ref={aptcRef}
                                            tabIndex={0}
                                            style={{ outline: 'none' }}
                                            className="tab-pane fade show active" id="nav-aptc" role="tabpanel"
                                                aria-labelledby="nav-aptc-tab"
                                                aria-label={overViewContent?.overview_aptc_title}
                                                aria-live="polite">
                                                { <APTCdetails />}
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {showSTPS && tableTabActiveKey === 'stps-info' && (
                                    <div className="card mt-4">
                                        <div className="card-body p-2">
                                            <div 
                                            ref={stpsRef}
                                            tabIndex={0}
                                            style={{ outline: 'none' }}
                                            className="tab-pane fade show active" id="nav-stps" role="tabpanel"
                                                aria-labelledby="nav-stps-tab"
                                                aria-label={overViewContent?.overview_stps_title}
                                                aria-live="polite">
                                                {<STPSDetails />}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                { showSTPS2 && tableTabActiveKey === 'stps2-info' &&(
                                    <div className="card mt-4">
                                        <div className="card-body p-2">
                                            <div 
                                            ref={stps2Ref}
                                            tabIndex={0}
                                            style={{ outline: 'none' }}
                                            className="tab-pane fade show active" id="nav-stps2" role="tabpanel"
                                                aria-labelledby="nav-stps2-tab"
                                                aria-label={overViewContent?.overview_stps2_title}
                                                aria-live="polite">
                                                { <STPS2Details />}
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {/* PMO0004087 CHG0127827 SD47534 */}
                                {showSTPS3 && tableTabActiveKey === 'stps3-info' && (
                                    <div className="card mt-4">
                                        <div className="card-body p-2">
                                            <div
                                                ref={stps3Ref}
                                                tabIndex={0}
                                                style={{ outline: 'none' }}
                                                className="tab-pane fade show active" id="nav-stps3" role="tabpanel"
                                                aria-labelledby="nav-stps3-tab"
                                                aria-label={overViewContent?.overview_stps3_title || 'STPS3'}
                                                aria-live="polite">
                                                { <STPS3Details /> }
                                            </div>
                                        </div>
                                    </div>
                                )} {/* PMO0004087 CHG0127827 SD47534*/}
                        </div>
                    </div>
                </div>
                <ViewDetailsModal column={modalColumns[modalId]} row={modalRows[modalId]} modal={modal} setModal={setModal} />

            </div >
        </main> {/*st48236 - 508 compliance*/}
        </>
    )
}
export default Overview;